import React from 'react';
import { Box } from '@wix/design-system';
import { TldAlternativeCard } from './TldAlternativeCard';
import { TldAlternativesSkeleton } from './TldAlternativesSkeleton';
export const TldAlternatives = _ref => {
  let alternatives = _ref.alternatives,
    isLoading = _ref.isLoading,
    disabled = _ref.disabled,
    onClickGetIt = _ref.onClickGetIt,
    dataHook = _ref.dataHook,
    _ref$useMobileLayout = _ref.useMobileLayout,
    useMobileLayout = _ref$useMobileLayout === void 0 ? false : _ref$useMobileLayout,
    _ref$useFullWidthSkel = _ref.useFullWidthSkeleton,
    useFullWidthSkeleton = _ref$useFullWidthSkel === void 0 ? false : _ref$useFullWidthSkel;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(TldAlternativesSkeleton, {
      limit: 3,
      useMobileLayout: useMobileLayout,
      useFullWidthSkeleton: useFullWidthSkeleton
    });
  }
  if (!alternatives.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: useMobileLayout ? 'vertical' : 'horizontal',
    gap: useMobileLayout ? 'SP3' : '18px',
    width: "100%",
    flexWrap: useMobileLayout ? 'nowrap' : 'wrap',
    dataHook: dataHook
  }, alternatives.map((alternative, index) => /*#__PURE__*/React.createElement(TldAlternativeCard, {
    key: alternative.id ?? alternative.domain ?? index,
    recommendation: alternative,
    onClick: onClickGetIt,
    disabled: disabled,
    dataHook: dataHook ? `${dataHook}-item-${index}` : undefined,
    useMobileLayout: useMobileLayout
  })));
};
//# sourceMappingURL=TldAlternatives.js.map